import { useContext } from "react";
import { AuthContext } from "./provide-auth";

export function useAuth() {
  return useContext(AuthContext);
}